import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";

export default function QcChemicalControlSection({
  mode = "edit",
  chemicalUsed = [],
  onChemicalChange,
  controlAgainst = {
    crawlingInsects: false,
    flyingInsects: false,
    rodentControl: false,
    others: false,
  },
  onControlAgainstChange,
  otherControlText = "",
  onOtherControlTextChange,
  errors = {},
}) {
  const readOnly = mode === "view";

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card variant="outlined">
          <CardHeader
            title={
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", textTransform: "uppercase" }}
              >
                Chemical/s Used
              </Typography>
            }
            sx={{ pb: 0, px: 2, pt: 2 }}
          />
          <CardContent sx={{ px: 2, pb: 2 }}>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell
                      align="center"
                      colSpan={2}
                      sx={{ fontWeight: "bold" }}
                    >
                      CHEMICAL/S USED
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {chemicalUsed.map((chemical, index) => (
                    <TableRow key={chemical.label || index}>
                      <TableCell sx={{ width: 80 }}>
                        {chemical.label}:
                      </TableCell>
                      <TableCell>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          value={chemical.chemical || ""}
                          onChange={(e) =>
                            !readOnly &&
                            onChemicalChange(index, "chemical", e.target.value)
                          }
                          disabled={readOnly}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <Card variant="outlined">
          <CardHeader
            title={
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", textTransform: "uppercase" }}
              >
                Control Against
              </Typography>
            }
            subheader="For Certificate"
            sx={{ pb: 0, px: 2, pt: 2 }}
          />
          <CardContent sx={{ px: 2, pb: 2 }}>
            <FormControl fullWidth error={!!errors?.control_against_count}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!controlAgainst.crawlingInsects}
                      onChange={onControlAgainstChange("crawlingInsects")}
                      disabled={readOnly}
                    />
                  }
                  label="Crawling Insects"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!controlAgainst.flyingInsects}
                      onChange={onControlAgainstChange("flyingInsects")}
                      disabled={readOnly}
                    />
                  }
                  label="Flying Insects"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!controlAgainst.rodentControl}
                      onChange={onControlAgainstChange("rodentControl")}
                      disabled={readOnly}
                    />
                  }
                  label="Rodent Control"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!controlAgainst.others}
                      onChange={onControlAgainstChange("others")}
                      disabled={readOnly}
                    />
                  }
                  label="Others"
                />
              </FormGroup>

              {controlAgainst.others && (
                <TextField
                  label="Please specify"
                  value={otherControlText}
                  onChange={(e) =>
                    !readOnly && onOtherControlTextChange(e.target.value)
                  }
                  fullWidth
                  size="small"
                  sx={{ mt: 1 }}
                  disabled={readOnly}
                  error={!!errors?.control_against_others_text}
                  helperText={errors?.control_against_others_text?.message || " "}
                />
              )}

              {!!errors?.control_against_count && (
                <FormHelperText>
                  {errors.control_against_count.message}
                </FormHelperText>
              )}
            </FormControl>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}